import Highcharts, { YAxisOptions } from "highcharts";
import { FORMATS } from "./constants";

export const lineChartOptions = (isDarkMode: boolean, format: string, unit: string) => ({
  series: [],
  credits: {
    enabled: false,
  },
  chart: {
    width: null,
    spacing: 10,
    zoomType: "x",
    panning: true,
    backgroundColor: isDarkMode ? "transparent" : "rgb(246,247,248)",
    panKey: "shift",
  },
  xAxis: {
    type: "datetime",
    gridLineWidth: 0,
    tickColor: "#E0E0E0",
    labels: {
      style: {
        color: isDarkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.60)",
      },
    },
    crosshair: {
      color: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)",
    },
    events: {},
  },
  yAxis: {
    gridLineColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)",
    labels: {
      format: "{value}",
      style: {
        color: isDarkMode ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.60)",
      },
    },
    opposite: false,
    crosshair: {
      width: 0,
    },
  } as Partial<YAxisOptions>,
  tooltip: {
    shared: true,
    split: true,
    useHTML: true,
    backgroundColor: "rgba(97, 97, 97, 0.90)",
    borderWidth: 0,
    shape: "rect",
    style: {
      color: "rgba(250, 249, 246, 1)",
      fontSize: "12px",
    },
    formatter: function () {
      if (!this.points) return;

      const dateStr = Highcharts.dateFormat("%A, %b %e, %Y", this.x);

      let combinedPrices = `<div style="font-size: 12px; padding: 4px;">`;

      this.points.forEach((point) => {
        const formattedValue = format === FORMATS.PRICE
          ? `$${point.y.toFixed(2)}`
          : point.point.change !== undefined
            ? `${(point.point.change >= 0 ? "+" : "")}${point.point.change.toFixed(2)}%` // in HC-converted percentage mode
            : `${point.y.toFixed(2)}${unit ?? ""}`;

        combinedPrices += `
        <div>
          <span style="color: ${point.series.color};">&#9679;</span>
          <span>${point.series.name}: </span>
          <span>${formattedValue}</span>
        </div>`;
      });

      combinedPrices += `</div>`;

      return [dateStr, combinedPrices];
    },
  },
  legend: {
    enabled: true,
    itemStyle: {
      fontSize: "14px",
      color: isDarkMode ? "white" : "black",
      pointerEvents: "none",
    },
    itemHoverStyle: {
      color: isDarkMode ? "white" : "black",
    },
    symbolWidth: 8,
    symbolHeight: 8,
    symbolRadius: 8,
    layout: "horizontal",
    align: "left",
    verticalAlign: "top",
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        symbol: "circle",
        states: {
          hover: {
            enabled: true,
            radius: 7,
            lineWidth: 0,
            halo: {
              attributes: {
                fill: "rgba(0, 0, 0, 0.2)",
                stroke: "none",
                opacity: 1,
              },
            },
          },
        },
      },
      states: {
        hover: {
          enabled: true,
          lineWidth: 2,
        },
      },
    },
  },
  stockTools: {
    gui: {
      enabled: false,
    },
  },
  rangeSelector: {
    inputPosition: {
      align: "right",
      x: 0,
      y: 0,
    },
    buttonPosition: {
      align: "left",
      x: -50,
      y: 0,
    },
    inputStyle: {
      color: isDarkMode ? "white" : "black",
      width: 103,
      height: 30,
      backgroundColor: isDarkMode ? "rgb(89,89,89)" : "white",
    },
    buttonTheme: {
      fill: "transparent",
      padding: 6,
      stroke: "none",
      style: {
        color: isDarkMode ? "white" : "black",
        textTransform: "uppercase",
      },
      states: {
        hover: {
          fill: "rgba(176, 190, 197, 0.16)",
        },
        select: {
          fill: "rgba(176, 190, 197, 0.16)",
          style: {
            color: isDarkMode ? "white" : "black",
          },
        },
      },
    },
  },
  navigator: {
    enabled: true,
    maskFill: "rgba(0, 158, 255, 0.12)",
    outlineColor: "rgba(153, 153, 153, 1)",
    series: {
      color: "rgba(144, 164, 174, 1)",
      lineWidth: 1,
    },
  },
});
